import { render, staticRenderFns } from "./SahabatZXLp.vue?vue&type=template&id=91d387ec"
import script from "./SahabatZXLp.vue?vue&type=script&lang=js"
export * from "./SahabatZXLp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports